import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
const progressVariants = cva('relative h-2 w-full overflow-hidden rounded-full bg-secondary', {
    variants: {
        variant: {
            default: '',
            primary: '',
            success: '',
            warning: '',
            danger: '',
        },
        size: {
            sm: 'h-1',
            default: 'h-2',
            lg: 'h-3',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
const progressIndicatorVariants = cva('h-full w-full flex-1 transition-all', {
    variants: {
        variant: {
            default: 'bg-primary',
            primary: 'bg-primary',
            success: 'bg-success',
            warning: 'bg-warning',
            danger: 'bg-destructive',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function Progress({ className, variant, size, value = 0, max = 100, indeterminate = false, ...props }) {
    const percentage = Math.min(100, Math.max(0, (value / max) * 100));
    return (_jsx("div", { role: "progressbar", "aria-valuenow": indeterminate ? undefined : value, "aria-valuemin": 0, "aria-valuemax": max, className: cn(progressVariants({ variant, size }), className), ...props, children: _jsx("div", { className: cn(progressIndicatorVariants({ variant }), indeterminate && 'animate-progress-indeterminate'), style: {
                transform: indeterminate ? undefined : `translateX(-${100 - percentage}%)`,
            } }) }));
}
export { Progress, progressVariants };
//# sourceMappingURL=progress.js.map